module.exports = __webpack_public_path__ + "img/single-source-of-truth.68f85be2.png";